// components/Selector.js
import React from 'react';
import {
  FormControl,
  MenuItem,
  Select,
  selectClasses,
  Typography,
  Box,
  Chip,
  FormHelperText,
} from '@mui/material';
import { gray } from '../shared-theme/themePrimitives';

const Selector = ({
  value,
  onChange,
  options = [],
  placeholder = 'Seleccione una opción',
  disabled = false,
  fullWidth = true,
  error = false,
  helperText = '',
  multiple = false,
  renderValue,
  ...restProps
}) => {
  const defaultRenderValue = (selected) => {
    if (multiple) {
      if (!selected || selected.length === 0) {
        return (
          <Typography color={gray?.[400] || 'text.secondary'}>
            {placeholder}
          </Typography>
        );
      }

      return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
          {selected.map((val) => {
            const item = options.find((opt) => opt.value === val);
            return (
              <Chip
                key={val}
                label={item?.label || val}
                sx={{ backgroundColor: '#e0e7ff', color: '#1e40af' }}
              />
            );
          })}
        </Box>
      );
    } else {
      const item = options.find((opt) => opt.value === selected);
      return item?.label || (
        <Typography color={gray?.[400] || 'text.secondary'}>
          {placeholder}
        </Typography>
      );
    }
  };

  return (
    <FormControl fullWidth={fullWidth} error={true} >
      <Select
        multiple={multiple}
        value={value}
        onChange={onChange}
        displayEmpty
        disabled={disabled}
        renderValue={renderValue || defaultRenderValue}
        inputProps={{ 'aria-label': placeholder }}
        sx={{
          backgroundColor: 'white',
          color: 'black',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: error ? '#d32f2f' : 'rgba(0, 0, 0, 0.23)',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: error ? '#d32f2f' : 'black',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: error ? '#d32f2f' : '#1976d2',
          },
          [`& .${selectClasses.select}`]: {
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            pl: 1,
          },
        }}
        {...restProps}
      >
        {!multiple && (
          <MenuItem value="" disabled>
            <Typography color={gray?.[400] || 'text.secondary'}>
              {placeholder}
            </Typography>
          </MenuItem>
        )}
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
            {option.description && (
              <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
                {option.description}
              </Typography>
            )}
          </MenuItem>
        ))}
      </Select>
      { error && (
        <FormHelperText>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
};

export default Selector;
